import { Action } from '../../shared/models/action.model';
import actionTypes from '../types/reconciliationTypes';
import { updateAction } from '../../utils/utility';
import { ReconciliationColumnFilterObject } from '../models/reconciliationModel';

export const updateReconciliationColumnFilters = (filters: ReconciliationColumnFilterObject[]): Action<any> =>
  updateAction(actionTypes.UPDATE_RECONCILIATION_COLUMN_FILTERS, filters);

export const downloadReconciliationFile = ({payload, url, extension, onSuccess = (): any => {},
  onError = (): any => {}}: any): Action<any> =>
  updateAction(actionTypes.DOWNLOAD_RECONCILIATION_FILE, {payload, url, extension, onSuccess, onError});

export const getReconciliationData = (payload: any): Action<any> =>
  updateAction(actionTypes.GET_RECONCILIATION_DATA, payload);

export const setReconciliationData = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_DATA, data);

export const setReconciliationInsurerFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_INSURER_FILTER, data);

export const setReconciliationTpaFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_TPA_FILTER, data);

export const setReconciliationCenterFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_CENTER_FILTER, data);

export const setReconciliationdodFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_DOD_FILTER, data);

export const setReconciliationUtrDateFilter = (data: any): Action<any> =>
updateAction(actionTypes.SET_RECONCILIATION_UTR_DATE_FILTER, data);

export const setReconciliationUtrNumberFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_UTR_NUMBER_FILTER, data);

export const setReconciliationSearchFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_SEARCH_FILTER, data);

export const setReconciliationViewIdFilter = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_VIEW_ID, data);

export const setReconciliationSortingKey = (data: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_SORTING_KEY, data);

export const setReconciliationClaimStatuses = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_CLAIM_STATUSES, payload);

export const setReconciliationStartIndex = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_START_INDEX, payload);

export const setReconciliationPageRange = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_PAGE_RANGE, payload);

export const setIsTableLoading = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_TABLE_LOADING, payload);

export const getInsurerWiseTds = (): Action<any> =>
  updateAction(actionTypes.GET_INSURER_WISE_TDS_RATES);

export const setIsTdsEditable = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_TDS_EDITABLE, payload);

export const setInsurerWiseTds = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_INSURER_WISE_TDS_RATES, payload);

export const updateInsurerWiseTdsRates = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_INSURER_WISE_TDS_RATES, payload);

export const setIsReconciliationEditable = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_IS_RECONCILIATION_EDITABLE, payload);

export const updateReconciliationData = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATE_RECONCILIATION_DATA, payload);

export const updatedReconciliationColsData = (payload: any): Action<any> =>
  updateAction(actionTypes.UPDATED_RECONCILIATION_COLS_DATA, payload);

export const setReconciliationClaimDetail = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_CLAIM_DETAIL, payload);

export const getReconciliationDetail = (payload: any): Action<any> =>
  updateAction(actionTypes.GET_RECONCILIATION_DETAIL, payload);

export const setReconciliationDetail = (payload: any): Action<any> =>
  updateAction(actionTypes.SET_RECONCILIATION_DETAIL, payload);
